import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';
import './Footer.css';

export function Footer() {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.split('-')[0];
  const dates =
    lng === 'en'
      ? siteConfig.event.dateHumanEn
      : lng === 'de'
      ? siteConfig.event.dateHumanDe
      : siteConfig.event.dateHumanCs;

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__mark" aria-label="Nicole & Jan">
          <img src="/assets/nj-mark.png" alt="" />
        </div>
        <div className="site-footer__tagline">{t('footer.tagline')}</div>
        <div className="site-footer__meta">
          {dates} · {siteConfig.event.venueName}
        </div>
      </div>
    </footer>
  );
}
